<template>
  <div id="map-controls-sidebar-settings">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activeSettingsSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <p class="aisea-text-18-700-white">設定</p>
            <small class="aisea-text-12-400-white">動静表の各種設定</small>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_SETTINGS_SIDEBAR(false)"
            class="cursor-pointer"
            svgClasses="live-map-controls-close"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>

        <component
          :is="scrollbarTag"
          class="scroll-area--customizer pt-4 pb-6"
          :settings="settings"
        >
          <div class="px-6">
            <default-position />
          </div>
          <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>
          <div class="mt-6 px-6">
            <own-vessel-display-duration-time />
          </div>
          <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {createNamespacedHelpers} from "vuex";
import DefaultPosition  from "./items/DefaultPosition";
import OwnVesselDisplayDurationTime from "./items/OwnVesselDisplayDurationTime";
// Mixins
import {ColorMixin} from "@/mixins";

const {
  mapState: mapStateOfLiveMap,
  mapMutations: mapMutationsOfLiveMap
} = createNamespacedHelpers("liveMap");

export default {
  mixins: [ColorMixin],
  components: {
    VuePerfectScrollbar,
    DefaultPosition,
    OwnVesselDisplayDurationTime
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
    };
  },
  watch: {},
  computed: {
    ...mapStateOfLiveMap({
      activeSettingsSidebar: state => state.activeSettingsSidebar
    }),
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_ACTIVE_SETTINGS_SIDEBAR",
    ]),
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#map-controls-sidebar-settings {
  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1.0;
  }
  .vs-tooltip{
    color: #0bb508 !important;
  }
}
</style>
